module.exports = __webpack_public_path__ + "img/google_spreadsheet_integration.855b795f.svg";